import { Button } from '@components';
import { baseURL } from '@services/env-variables';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AnoMesContraCheque } from '../components/AnoMesContracheque';

export const ContrachequePage = () => {
  const navigate = useNavigate();
  const [urlPDFExtrato, setUrlPDFExtrato] = useState('');
  const { matricula, token } = useSelector((state) => state.user.data);

  useEffect(() => {
    setUrlPDFExtrato(
      `${baseURL}ObterContraChequeParticipante?matricula=${matricula}&token=${token}&anomes=`
    );
  }, [matricula, token]);

  return (
    <>
      <Helmet>
        <title>Forluz - Contracheque</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Contracheque</strong>
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <AnoMesContraCheque urlGetPDF={urlPDFExtrato} relatorio="contracheque" />
    </>
  );
};
